import * as React from 'react';
import { cn } from '../../lib/cn';

type Tone = 'neutral' | 'accent' | 'warn' | 'success' | 'muted';

const TONES: Record<Tone, string> = {
  neutral: 'bg-ink-100 text-ink-700 dark:bg-ink-800 dark:text-ink-200',
  accent: 'bg-accent-50 text-accent-700 dark:bg-accent-900 dark:text-accent-100',
  warn: 'bg-amber-50 text-warn-600 dark:bg-warn-600/15 dark:text-amber-200',
  success: 'bg-emerald-50 text-emerald-700 dark:bg-emerald-900/40 dark:text-emerald-200',
  muted: 'bg-ink-50 text-ink-500 dark:bg-ink-900 dark:text-ink-400',
};

export function Pill({ tone = 'neutral', className, children }: { tone?: Tone; className?: string; children: React.ReactNode }) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-xs font-medium',
        TONES[tone],
        className,
      )}
    >
      {children}
    </span>
  );
}
